import React from "react"
import PropTypes from "prop-types"
import MediaQuery from "react-responsive"
import classNames from "classnames"

//	Configs
import BreakPointConfig from "components/Stacker/constants/breakpoints"

// Components
//import Share from "components/Stacker/components/Share/Share"
import Print from "components/Stacker/components/Print/Print"

import "./ProductDetails.scss"
import { useI18nContext } from "i18n/i18n-react"

// this should hold the Product Sizes on PDP page.
function ProductDetails({
  products,
  selectedVariant,
  selectedVariant: { productName },
  selectedSize,
  products: { imageURL },
  isGiftCard,
  sendType,
}) {
  const { LL } = useI18nContext()
  const description = selectedVariant.description
    ? selectedVariant.description
    : products.description

  const styleNumber = selectedSize
    ? selectedSize.styleNumber
    : selectedVariant.styleNumber

  const showFitCare =
    !isGiftCard && (selectedVariant.metalCare || selectedVariant.stoneCare)
  const careText = LL.pdp.careText()
  const isCareTextPresent = careText.length > 0

  return (
    <div className="ProductDetails d-flex">
      <div className="product-description-container">
        <p className="product-detail-label productdetails">
          {LL.generic.productDetailsLabel()}
        </p>

        <div
          className="product-description"
          dangerouslySetInnerHTML={{ __html: description }} // eslint-disable-line react/no-danger
        />
        <p>
          {LL.generic.styleNumberLabel()}: {styleNumber}
        </p>

        <div className="d-flex external-ctas">
          <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
            <Print />
          </MediaQuery>
          {/* <Share
            productTitle={productName}
            productImageUrl={imageURL}
            pid={isGiftCard ? products.productId : selectedVariant.code}
            sendType={sendType}
          /> */}
        </div>
      </div>
      <div className="fit-care-container">
        {showFitCare && (
          <div className="fitandcare_desc">
            <p className="product-detail-label fitandcare">
              {LL.pdp.fitAndCareText()}
            </p>
            {selectedVariant.metalCare && (
              <p className="care-category">
                <span className="care-category-label text-uppercase">
                  {`${LL.productConfig.metalLabel()}: `}
                </span>
                <span className="care-category-description">
                  {selectedVariant.metalCare.join(" ")}
                </span>
              </p>
            )}
            {selectedVariant.stoneCare && (
              <p className="care-category">
                <span className="care-category-label text-uppercase">
                  {`${LL.pdp.gemStoneLabel()}: `}
                </span>
                <span className="care-category-description">
                  {selectedVariant.stoneCare.join(" ")}
                </span>
              </p>
            )}
            {isCareTextPresent && (
              <p className="care-category">
                <span
                  className="care-category-description care-category-careText"
                  dangerouslySetInnerHTML={{
                    __html: careText,
                  }}
                />
              </p>
            )}
          </div>
        )}
        <div className="needhelp_desc">
          <p
            className={classNames("product-detail-label", {
              "need-help-label": !!showFitCare,
            })}
          >
            {LL.generic.customerServiceLabel()}
          </p>
          <p>{LL.generic.customerServiceText()}</p>
          <a
            href={`tel:${LL.generic.customerServiceNo()}`}
            className="c-btn tertiary"
          >
            {LL.generic.customerServiceNoLabel()}
          </a>
          <span>Contact Customer Care</span>
        </div>
      </div>
    </div>
  )
}

ProductDetails.propTypes = {
  products: PropTypes.object,
  selectedVariant: PropTypes.object,
  selectedSize: PropTypes.object,
  isGiftCard: PropTypes.bool,
  sendType: PropTypes.string,
}

export default ProductDetails
